import videoClass from "@/views/ielts-webapp/ielts-webapp-videoClass/index.vue";
import leadStudy from "@/views/ielts-webapp/ielts-webapp-leadStudy/index.vue"

export default [{
        path: '/ielts-webapp/videoClass',
        name: 'ielts-webapp-videoClass',
        meta: {
            title: "ielts-webapp-videoClass",
            requiresAuth: false,
        },
        component: videoClass
    },
    {
        path: '/ielts-webapp/leadStudy',
        name: 'ielts-webapp-leadStudy',
        meta: {
            title: "ielts-webapp-leadStudy",
            requiresAuth: false,
        },
        component: leadStudy
    }

]